export default __webpack_public_path__ + "static/media/932.bd9375c0.jpg";